import React from "react";
const IconChevronLeft = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M12.75 4.5L7.25 10L12.75 15.5" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
  </svg>
);
export default IconChevronLeft;
